var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0512 0.879009C12.4886 0.316199 11.7254 0 10.9295 0C10.1337 0 9.37053 0.316199 8.8079 0.879009L0.322297 9.36311C0.134723 9.55063 0.029327 9.80498 0.0292969 10.0702V12.8984C0.0292969 13.4507 0.477012 13.8984 1.0293 13.8984H3.8583C4.12355 13.8985 4.37794 13.7931 4.5654 13.6054L13.052 5.12081C14.2189 3.94752 14.2186 2.05186 13.0512 0.879009ZM11.6361 2.29284C12.0256 2.6836 12.026 3.31563 11.6371 3.70694L10.9299 4.41414L9.51511 2.99974L10.222 2.29284C10.6125 1.90239 11.2456 1.90239 11.6361 2.29284ZM2.02939 11.899H3.44439L9.51569 5.82846L8.10079 4.41406L2.02939 10.4849V11.899Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDark);
export default __webpack_public_path__ + "static/media/edit_dark.99c6dbe19db839141484bdf894ace66d.svg";
export { ForwardRef as ReactComponent };